{
  "menu": {
    "description": "Resident menu",
    "items": [
      {
        "index": 0,
        "route": "content/resident/dashboard",
        "label": "DASHBOARD",
        "icon": "arrow_forward"
      },
      {
        "index": 2,
        "route": "request",
        "label": "CREATE_REQUEST",
        "icon": "arrow_forward"
      }
    ]
  }
}
